import {
  TweenLite, 
  Power4
} from 'gsap';

export default (el, distance) => {
  TweenLite.to(el, 1, { y: distance, ease: Power4.easeOut });
}
